import { render, staticRenderFns } from "./Question20.vue?vue&type=template&id=598dd4ec&scoped=true&"
import script from "./Question20.vue?vue&type=script&lang=js&"
export * from "./Question20.vue?vue&type=script&lang=js&"
import style0 from "./Question20.vue?vue&type=style&index=0&id=598dd4ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598dd4ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCheckbox,VForm})
